
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetomahabaleshwercab() {



    const cardData =
    {
        keyword: ' Pune to Mahabaleshwar cab',
        heading: 'S9 Travels:  Pune to Mahabaleshwar cab',
        headingDescription: 'S9 Travels offers dependable and affordable Pune to Mahabaleshwar cab services, perfect for weekend getaways, family trips, or peaceful vacations in the hills. The distance between Pune and Mahabaleshwar is approximately 120 kilometers, and the scenic journey takes about 3 to 4 hours via well-maintained highways.',

        top: 'Top Places to Visit in Mahabaleshwar with S9 Travels',

"topPlaces": [
    {
      "title": "Arthur's Seat",
      "description": "Arthur's Seat is one of the most popular viewpoints in Mahabaleshwar, offering stunning panoramic views of the valleys and the Savitri River below."
    },
    {
      "title": "Venna Lake",
      "description": "A serene lake surrounded by lush greenery, Venna Lake is perfect for boating, horse riding, and enjoying the beautiful natural scenery."
    },
    {
      "title": "Mapro Garden",
      "description": "Mapro Garden is famous for its fresh strawberry produce, delicious fruit-based products, and a café serving strawberry-based desserts."
    },
    {
      "title": "Pratapgad Fort",
      "description": "A historic fort built by Chhatrapati Shivaji Maharaj, Pratapgad Fort offers stunning views, rich history, and an insight into Maratha architecture."
    },
    {
      "title": "Elephant’s Head Point",
      "description": "This unique rock formation resembles an elephant’s head and trunk, offering breathtaking views of the surrounding valleys."
    },
    {
      "title": "Wilson Point",
      "description": "Wilson Point is the highest point in Mahabaleshwar, known for offering mesmerizing sunrise and sunset views."
    },
    {
      "title": "Lodwick Point",
      "description": "A famous viewpoint with a statue of General Lodwick, this place provides scenic views of the surrounding mountains and valleys."
    },
    {
      "title": "Lingmala Waterfall",
      "description": "One of the most beautiful waterfalls in Mahabaleshwar, Lingmala Waterfall is a perfect spot to enjoy nature and relax."
    },
    {
      "title": "Panchgani",
      "description": "A scenic hill station near Mahabaleshwar, Panchgani is famous for its tableland, lush greenery, and strawberry farms."
    },
    {
      "title": "Krishnabai Temple",
      "description": "This ancient temple dedicated to Goddess Krishna offers peaceful surroundings and panoramic views of the Krishna River."
    }
],

"services": [
  {
    "name": "Pune to Mahabaleshwar Cab Service",
    "description": "Book trusted Pune to Mahabaleshwar cab services with S9 Travels. Ideal for family vacations, romantic trips, or weekend escapes, our cabs ensure comfort, safety, and scenic travel."
  },
  {
    "name": "Book Pune to Mahabaleshwar Taxi Online",
    "description": "Easily book your Pune to Mahabaleshwar taxi online. Choose from AC sedans, SUVs, or Innova Crysta for a smooth ride through the hills with trained drivers and flexible pickup timings."
  },
  {
    "name": "Affordable Cab from Pune to Mahabaleshwar",
    "description": "Travel on a budget with our affordable Pune to Mahabaleshwar cab options. Enjoy transparent pricing, clean vehicles, and reliable service — perfect for short trips and quick getaways."
  },
  {
    "name": "Private Taxi to Mahabaleshwar from Pune",
    "description": "Prefer privacy? Book a private Pune to Mahabaleshwar cab for a relaxed, personal journey. Great for couples, solo travelers, or families who want exclusive comfort on the way to the hills."
  },
  {
    "name": "Pune to Mahabaleshwar One-Way & Round Trip Taxi",
    "description": "Need flexibility? We offer both one-way and round-trip cabs from Pune to Mahabaleshwar, ideal for weekend return plans or extended vacations. Book your route as per your itinerary."
  },
  {
    "name": "Luxury Pune to Mahabaleshwar Cab",
    "description": "Upgrade your hill station ride with a luxury cab. Our Pune to Mahabaleshwar Crysta and premium SUVs come with plush interiors and smooth suspension for top-tier comfort."
  },
  {
    "name": "Comfort Ride to Mahabaleshwar from Pune",
    "description": "Experience the difference with our comfort-focused Pune to Mahabaleshwar taxi. Spacious seating, smooth road handling, and courteous drivers ensure a relaxing travel experience."
  },
  {
    "name": "Mahabaleshwar Local Sightseeing Taxi from Pune",
    "description": "Explore Mahabaleshwar’s best spots with our sightseeing cab service. Visit Arthur’s Seat, Venna Lake, temples, and viewpoints — all with an expert local driver from Pune."
  },
  {
    "name": "Group Travel Cab to Mahabaleshwar from Pune",
    "description": "Planning a group trip? Book a spacious Tempo Traveller or SUV from Pune to Mahabaleshwar. Plenty of space for passengers and luggage for smooth and coordinated group travel."
  }
],
  "tableData": [
    ["Pune to Mahabaleshwar Cab Service", "Book Pune to Mahabaleshwar Taxi"],
    ["Affordable Pune to Mahabaleshwar Cab", "Private Taxi for Mahabaleshwar from Pune"],
    ["Pune to Mahabaleshwar One-Way or Round Trip", "Luxury Cab from Pune to Mahabaleshwar"],
    ["Comfortable Taxi Ride for Mahabaleshwar", "Mahabaleshwar Sightseeing by Taxi from Pune"],
    ["Group Travel to Mahabaleshwar from Pune", "Pune to Mahabaleshwar One-Way or Round Trip"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we prioritize punctuality. Whether you're heading from Pune to Mahabaleshwar for a weekend getaway or a quick trip, we guarantee on-time pickups and smooth rides, ensuring you reach your destination without any hassle."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the perfect choice for your Pune to Mahabaleshwar journey. With comfortable seating, air conditioning, and plenty of space for your luggage, you’ll enjoy a relaxing and stress-free ride, whether you're traveling alone or with family and friends."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced, professional, and familiar with the best routes to Mahabaleshwar. They ensure a smooth and safe journey with their expert knowledge of the roads and commitment to providing top-notch service, allowing you to enjoy a worry-free trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Mahabaleshwar ride. You’ll receive a clear breakdown of all costs upfront, with no hidden charges, so you can travel comfortably without worrying about unexpected expenses."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. You can relax and enjoy your journey, knowing that your comfort and safety are guaranteed."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7, ensuring you can travel from Pune to Mahabaleshwar at any time of day or night. Whether it's an early morning trip or a late-night return, we’re ready to serve you, and our customer service team is always available to assist with bookings."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Mahabaleshwar cab is simple and easy with S9 Travels. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance in reserving your ride."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your Pune to Mahabaleshwar trip. Whether you need additional stops along the way or have specific requests, we can tailor your trip to suit your preferences and make your journey more enjoyable."
  }
]








    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Pune to Mahabaleshwar with S9 Travels?',
            answer: 'Booking a cab for your Pune to Mahabaleshwar trip is simple! You can book online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Pune to Mahabaleshwar travel?',
            answer: 'We offer a variety of vehicles, including the spacious Toyota Innova, perfect for families, groups, or travelers with a lot of luggage. Choose the vehicle that suits your needs for a comfortable and scenic journey to Mahabaleshwar.'
          },
          {
            question: 'Are the drivers experienced for the Pune to Mahabaleshwar route?',
            answer: 'Yes, our drivers are experienced and familiar with the best routes from Pune to Mahabaleshwar. They ensure a smooth, safe, and enjoyable journey through the beautiful hill stations.'
          },
          {
            question: 'What payment options are available for booking a cab from Pune to Mahabaleshwar?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and secure online payments via our app, making it easy and convenient to pay for your ride.'
          },
          {
            question: 'Can I book a round trip from Pune to Mahabaleshwar?',
            answer: 'Yes, we offer round-trip bookings. Just provide us with your return details, and we’ll ensure your ride back from Mahabaleshwar to Pune is as smooth and comfortable as your trip there.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges for detours or waiting time will be communicated to you upfront, ensuring transparency in pricing.'
          },
          {
            question: 'Can I make additional stops on the way to Mahabaleshwar?',
            answer: 'Yes, you can request additional stops along the way. Please inform us during the booking process, and we will accommodate your requests for detours or stops on your journey to Mahabaleshwar.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Pune to Mahabaleshwar trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or special requirements, please let us know during booking, and we will make necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Pune to Mahabaleshwar?',
            answer: 'Yes, we offer corporate travel services for business trips from Pune to Mahabaleshwar, ensuring a professional, comfortable, and timely service for your business needs.'
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Mahabaleshwar cab booking?',
            answer: 'S9 Travels provides a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey from Pune to Mahabaleshwar.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sanjay Kulkarni',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels from Pune to Mahabaleshwar for a weekend getaway, and it was a fantastic experience. The driver was friendly, the vehicle was spacious and clean, and the journey was smooth. I highly recommend S9 Travels for anyone traveling to Mahabaleshwar!”'
        },
        {
          name: 'Mrs. Radhika Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family trip from Pune to Mahabaleshwar with S9 Travels was amazing. The vehicle was well-maintained, the driver was professional, and the entire journey was comfortable and enjoyable. I’ll definitely book again with S9 Travels for future trips.”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Cab",
  "image": "https://www.s9travels.com/images/keyword/pune-to-mahabaleshwar-cab.jpg", // Replace with actual image URL
  "description": "Book your Pune to Mahabaleshwar cab with S9 Travels for a scenic, safe, and comfortable hill station journey. We offer one-way and round-trip options with clean AC sedans, SUVs, and luxury cars. Enjoy timely pickups, experienced drivers, and affordable pricing for your trip from Pune to Mahabaleshwar.",
  "brand": {
    "@type": "Brand",
    "name": "S9 Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3221"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.s9travels.com/Pune-to-Mahabaleshwar-Cab"
  }
};

      
     

      
      
      


    return (
        <div>
 <Helmet>
  <title>Pune to Mahabaleshwar Cab Booking | Scenic One Way & Round Trip Taxi - S9 Travels</title>

  <meta 
    name="description" 
    content="Enjoy a scenic and comfortable Pune to Mahabaleshwar cab ride with S9 Travels. Book one-way or round-trip taxis with AC sedans, SUVs, and Innova. Affordable fares, expert drivers, and 24x7 support." 
  />

  <meta 
    name="keywords" 
    content="Pune to Mahabaleshwar Cab, Cab from Pune to Mahabaleshwar, Book Pune to Mahabaleshwar Taxi, One Way Pune to Mahabaleshwar Taxi, Round Trip Cab Pune Mahabaleshwar, Mahabaleshwar Weekend Trip Taxi, AC Cabs Pune Mahabaleshwar, S9 Travels Mahabaleshwar Cab Booking, Luxury Taxi Pune to Mahabaleshwar" 
  />

  <link rel="canonical" href="https://s9travels.com/pune-to-mahabaleshwar-cab" />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/98.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomahabaleshwercab;